<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showcoupons") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.coupon_name')"
            v-model.trim="data.nameAr"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.coupon_nameEN')"
            v-model.trim="data.nameEn"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.code')"
            v-model="data.code"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discountPercentage')"
            v-model="data.discount_percentage"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.allowed_for_festivals')"
              v-model="data.allowed_for_festivals"
              hide-details
              disabled
            ></v-switch>
          </div>
          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.allowed_for_orders')"
              v-model="data.allowed_for_orders"
              hide-details
              disabled
            ></v-switch>
          </div>

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.has_maximum_amount')"
              v-model="data.has_maximum_amount"
              hide-details
              disabled
            ></v-switch>
          </div>
          <base-input
            v-if="data.has_maximum_amount"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.maximum_amount')"
            v-model="data.maximum_amount"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.has_limited_usage')"
              v-model="data.has_limited_usage"
              hide-details
              disabled
            ></v-switch>
          </div>
          <base-input
            v-if="data.has_limited_usage"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.usage_limit')"
            v-model="data.usage_limit"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.count_uses_coupon')"
            v-model="data.usage_count"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="
                data.allowed_for_all
                  ? $t('PLACEHOLDERS.chooseAll')
                  : $t('PLACEHOLDERS.choose')
              "
              v-model="data.allowed_for_all"
              hide-details
              disabled
            ></v-switch>
          </div>

          <base-select-input
            v-if="!data.allowed_for_all"
            multiple
            col="6"
            :optionsList="data.allowed_clients"
            :placeholder="$t('PLACEHOLDERS.allowed_clients')"
            v-model="data.allowed_clients"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowCoupon",

  data() {
    return {
      data: {
        nameAr: null,
        nameEn: null,
        code: null,
        discount_percentage: null,
        allowed_for_festivals: false,
        allowed_for_orders: false,
        has_maximum_amount: false,
        maximum_amount: null,
        has_limited_usage: false,
        usage_limit: null,
        usage_count: 0,
        allowed_for_all: true,
        allowed_clients: [],
        is_active: false,
      },
    };
  },

  methods: {
    async showCoupon() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `coupons/${this.$route.params.id}`,
        });
        const coupon = res.data.data.Coupon || res.data.data;
        this.data.nameAr = coupon.name_ar;
        this.data.nameEn = coupon.name_en;
        this.data.code = coupon.code;
        this.data.discount_percentage = coupon.discount_percentage;
        this.data.allowed_for_festivals = !!coupon.allowed_for_festivals;
        this.data.allowed_for_orders = !!coupon.allowed_for_orders;
        this.data.has_maximum_amount = !!coupon.has_maximum_amount;
        this.data.maximum_amount = coupon.maximum_amount;
        this.data.has_limited_usage = !!coupon.has_limited_usage;
        this.data.usage_limit = coupon.usage_limit;
        this.data.usage_count = coupon.usage_count ?? 0;
        this.data.allowed_for_all = !!coupon.allowed_for_all;
        this.data.is_active = !!coupon.is_active;
        this.data.allowed_clients = (coupon.allowed_clients || []).map(
          (client) => ({
            id: client.id,
            name: client.name || client.mobile || String(client.id),
          })
        );
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
  },

  created() {
    this.showCoupon();
  },
};
</script>
